import {
  Avatar,
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  Flex,
  Link,
  Text,
  Input,
} from "@chakra-ui/react";
import { Separator } from "components/Separator/Separator";
import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import heart from "assets/img/heart.png";
import moment from "moment";
import { useDisclosure, Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton } from "@chakra-ui/react";
import useCustomToast from "components/Toast/useCustomToast";

import { useFetchData, usePostData } from "apiService";

export default function Configurator(props) {
  const { secondary, isOpen, onClose, fixed, ...rest } = props;
  const [switched, setSwitched] = useState(props.isChecked);
  const { data: currentUsers } = useFetchData('users/0');
  const [currentUser, setCurrentUser] = useState(null);
  const [editedUser, setEditedUser] = useState({});
  const [haveModification, setHaveModification] = useState(false);

  // État et méthodes pour la pop-up de modification de mot de passe
  const { isOpen: isPasswordModalOpen, onOpen: onPasswordModalOpen, onClose: onPasswordModalClose } = useDisclosure();
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const { success, error } = useCustomToast();
  const { postData } = usePostData();

  useEffect(() => {
    setCurrentUser(currentUsers[0]);
    if (currentUsers[0]) {
      setEditedUser({
        firstname: currentUsers[0].firstname,
        name: currentUsers[0].name,
        avatar_url: currentUsers[0].avatar_url,
        nigend: currentUsers[0].nigend,
        phone: currentUsers[0].phone,
        discord: currentUsers[0].discord
      });
    }
  }, [currentUsers]);

  // Gérer les changements dans les champs d'entrée
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedUser({ ...editedUser, [name]: value });
    setHaveModification(true);
  };

  // Sauvegarder les modifications
  const saveChanges = async () => {
    if (!haveModification) return;
    try {
      const response = await postData('editMyAccount', editedUser);

      if (response) {
        setCurrentUser({ ...currentUser, ...editedUser });
        setHaveModification(false);
        success('Modifications enregistrées');
      }
    } catch (err) {
      error('Erreur', 'Impossible de sauvegarder les modifications');
    }
  };

  const changePassword = () => {

    // Mots de passe ne correspondent pas
    if (newPassword !== confirmNewPassword) {
      error('Erreur', 'Les mots de passe ne correspondent pas');
      return;
    }

    // Mots de passe trop courts
    if (newPassword.length < 3) {
      error('Erreur', 'Le mot de passe doit contenir au moins 3 caractères');
      return;
    }

    // Envoi de la requête de changement de mot de passe
    try {
      const response = postData('changePassword', { newPassword });

      if (response) {
        success('Mot de passe modifié');
      }

    } catch (err) {
      error('Erreur', 'Impossible de modifier le mot de passe');
    }

    // Fermer la pop-up
    onPasswordModalClose();
  };

  // Chakra Color Mode
  let fixedDisplay = "flex";
  if (props.secondary) {
    fixedDisplay = "none";
  }
  let colorButton = "white";
  const secondaryButtonColor = "white";
  const settingsRef = React.useRef();
  return (
    <>
      <Drawer
        isOpen={props.isOpen}
        onClose={props.onClose}
        placement={document.documentElement.dir === "rtl" ? "left" : "right"}
        finalFocusRef={settingsRef}
        blockScrollOnMount={false}>
        <DrawerContent
          bg='linear-gradient(111.84deg, rgba(6, 11, 38, 0.94) 59.3%, rgba(26, 31, 55, 0) 100%)'
          backdropFilter='blur(42px)'>
          <DrawerHeader pt='24px' px='24px'>
            <DrawerCloseButton color='white' />
            <Flex justifyContent={"center"} py='.8rem' minWidth='100%' flexWrap='nowrap'>
              <Avatar
                src={editedUser.avatar_url}
                w='100px'
                h='100px'
                borderRadius='12px'
                border='none'
                name={editedUser.firstname}
              />
            </Flex>
            <Text textAlign={"center"} color='white' fontSize='xl' fontWeight='bold' mt='16px'>
              {editedUser ? editedUser.firstname + " " + editedUser.name : '???'}
            </Text>
            <Text textAlign={"center"} color='gray.400' fontSize='xl' fontWeight='bold' mb='16px'>
              {currentUser ? currentUser.grade : '???'}
            </Text>
            <Text textAlign={"center"} color='gray.400' fontSize='sm' mb='4px'>{currentUser ? "Depuis le " + moment(currentUser.date_creation).format('DD MMMM yyyy') : '???'}</Text>
            <Separator />
          </DrawerHeader>
          <DrawerBody w='340px' ps='24px' pe='40px'>
            <Flex flexDirection='column'>

              {/* Section Avatar */}
              <Box
                p='16px'
                bg='rgba(255, 255, 255, 0.03)'
                borderRadius='12px'
                mb='16px'
              >
                <Text color='gray.400' fontSize='xs' fontWeight='600' textTransform='uppercase' letterSpacing='wider' mb='8px'>
                  Image de profil
                </Text>
                <Input
                  name="avatar_url"
                  value={editedUser ? editedUser.avatar_url : '???'}
                  onChange={handleInputChange}
                  color='white'
                  fontSize='14px'
                  bg='rgba(255, 255, 255, 0.05)'
                  border='1px solid'
                  borderColor='rgba(255, 255, 255, 0.1)'
                  borderRadius='8px'
                  _hover={{ borderColor: 'rgba(255, 255, 255, 0.2)' }}
                  _focus={{ borderColor: 'blue.400', boxShadow: '0 0 0 1px #4299E1' }}
                />
              </Box>

              {/* Section Identité */}
              <Box
                p='16px'
                bg='rgba(255, 255, 255, 0.03)'
                borderRadius='12px'
                mb='16px'
              >
                <Text color='gray.400' fontSize='xs' fontWeight='600' textTransform='uppercase' letterSpacing='wider' mb='12px'>
                  Identité
                </Text>
                <Flex gap='12px' mb='12px'>
                  <Box flex='1'>
                    <Text color='gray.500' fontSize='xs' mb='4px'>Prénom</Text>
                    <Input
                      name="firstname"
                      value={editedUser ? editedUser.firstname : '???'}
                      onChange={handleInputChange}
                      color='white'
                      fontSize='14px'
                      bg='rgba(255, 255, 255, 0.05)'
                      border='1px solid'
                      borderColor='rgba(255, 255, 255, 0.1)'
                      borderRadius='8px'
                      _hover={{ borderColor: 'rgba(255, 255, 255, 0.2)' }}
                      _focus={{ borderColor: 'blue.400', boxShadow: '0 0 0 1px #4299E1' }}
                    />
                  </Box>
                  <Box flex='1'>
                    <Text color='gray.500' fontSize='xs' mb='4px'>Nom</Text>
                    <Input
                      name="name"
                      value={editedUser ? editedUser.name : '???'}
                      onChange={handleInputChange}
                      color='white'
                      fontSize='14px'
                      bg='rgba(255, 255, 255, 0.05)'
                      border='1px solid'
                      borderColor='rgba(255, 255, 255, 0.1)'
                      borderRadius='8px'
                      _hover={{ borderColor: 'rgba(255, 255, 255, 0.2)' }}
                      _focus={{ borderColor: 'blue.400', boxShadow: '0 0 0 1px #4299E1' }}
                    />
                  </Box>
                </Flex>
                <Box>
                  <Text color='gray.500' fontSize='xs' mb='4px'>RIO / NIGEND</Text>
                  <Input
                    name="nigend"
                    value={editedUser ? editedUser.nigend : '???'}
                    onChange={handleInputChange}
                    color='white'
                    fontSize='14px'
                    bg='rgba(255, 255, 255, 0.05)'
                    border='1px solid'
                    borderColor='rgba(255, 255, 255, 0.1)'
                    borderRadius='8px'
                    _hover={{ borderColor: 'rgba(255, 255, 255, 0.2)' }}
                    _focus={{ borderColor: 'blue.400', boxShadow: '0 0 0 1px #4299E1' }}
                  />
                </Box>
              </Box>

              {/* Section Contact */}
              <Box
                p='16px'
                bg='rgba(255, 255, 255, 0.03)'
                borderRadius='12px'
                mb='20px'
              >
                <Text color='gray.400' fontSize='xs' fontWeight='600' textTransform='uppercase' letterSpacing='wider' mb='12px'>
                  Contact
                </Text>
                <Box mb='12px'>
                  <Text color='gray.500' fontSize='xs' mb='4px'>N° de téléphone</Text>
                  <Input
                    name="phone"
                    value={editedUser ? editedUser.phone : '???'}
                    onChange={handleInputChange}
                    color='white'
                    fontSize='14px'
                    bg='rgba(255, 255, 255, 0.05)'
                    border='1px solid'
                    borderColor='rgba(255, 255, 255, 0.1)'
                    borderRadius='8px'
                    _hover={{ borderColor: 'rgba(255, 255, 255, 0.2)' }}
                    _focus={{ borderColor: 'blue.400', boxShadow: '0 0 0 1px #4299E1' }}
                  />
                </Box>
                <Box>
                  <Text color='gray.500' fontSize='xs' mb='4px'>Discord</Text>
                  <Input
                    name="discord"
                    value={editedUser ? editedUser.discord : '???'}
                    onChange={handleInputChange}
                    color='white'
                    fontSize='14px'
                    bg='rgba(255, 255, 255, 0.05)'
                    border='1px solid'
                    borderColor='rgba(255, 255, 255, 0.1)'
                    borderRadius='8px'
                    _hover={{ borderColor: 'rgba(255, 255, 255, 0.2)' }}
                    _focus={{ borderColor: 'blue.400', boxShadow: '0 0 0 1px #4299E1' }}
                  />
                </Box>
              </Box>

              {/* Boutons d'action */}
              <Button
                bg={haveModification ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 'rgba(255, 255, 255, 0.05)'}
                color={haveModification ? 'white' : 'gray.500'}
                variant='solid'
                size='md'
                fontWeight='600'
                w='100%'
                borderRadius='10px'
                _hover={{
                  bg: haveModification ? 'linear-gradient(135deg, #5a6fd6 0%, #6a4190 100%)' : 'rgba(255, 255, 255, 0.08)',
                  transform: haveModification ? 'translateY(-2px)' : 'none'
                }}
                transition='all 0.2s'
                onClick={saveChanges}
                isDisabled={!haveModification}
              >
                Enregistrer les modifications
              </Button>

              <Button
                bg='rgba(237, 137, 54, 0.15)'
                color='orange.400'
                variant='solid'
                size='md'
                fontWeight='600'
                mt='12px'
                w='100%'
                borderRadius='10px'
                border='1px solid'
                borderColor='rgba(237, 137, 54, 0.3)'
                _hover={{
                  bg: 'rgba(237, 137, 54, 0.25)',
                  borderColor: 'orange.400'
                }}
                transition='all 0.2s'
                onClick={onPasswordModalOpen}
              >
                Modifier mon mot de passe
              </Button>

              {/* Footer XGuard */}
              <Flex
                direction='column'
                align='center'
                mt='24px'
                pt='16px'
                borderTop='1px solid rgba(255, 255, 255, 0.08)'
              >
                <img src={heart} width="40px" alt="Logo" style={{ opacity: 0.8 }} />
                <Text color='gray.500' fontSize='xs' mt='8px' textAlign='center'>
                  Merci d'utiliser XGuard !
                </Text>
                <Text color='gray.600' fontSize='xs' textAlign='center'>
                  Par
                  <Link
                    href='https://www.nelx.net'
                    color='orange.400'
                    fontWeight='600'
                    _hover={{ color: 'orange.300' }}
                  > NELX
                  </Link>
                </Text>
              </Flex>
            </Flex>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
      {/* Modal pour le changement de mot de passe */}
      <Modal isOpen={isPasswordModalOpen} onClose={onPasswordModalClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Changer mon mot de passe</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <Input type="password" placeholder='Nouveau mot de passe' value={newPassword} onChange={(e) => setNewPassword(e.target.value)} mb={3} />
            <Input type="password" placeholder='Confirmez le nouveau mot de passe' value={confirmNewPassword} onChange={(e) => setConfirmNewPassword(e.target.value)} />
          </ModalBody>

          <ModalFooter>
            <Button colorScheme='blue' mr={3} onClick={changePassword}>
              Modifier mon mot de passe
            </Button>
            <Button onClick={onPasswordModalClose}>Annuler</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
Configurator.propTypes = {
  secondary: PropTypes.bool,
  isOpen: PropTypes.func,
  onClose: PropTypes.func,
  fixed: PropTypes.bool,
};